import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";
import contains from "ramda/src/contains";
import not from "ramda/src/not";
import and from "ramda/src/and";
import find from "ramda/src/find";
import keys from "ramda/src/keys";

import { removeAccents } from "services/utils/validation";

import Wizard from "../Wizard";
import WizardStep from "../Wizard/WizardStep";
import WizardSwitch from "../Wizard/WizardSwitch";
import QueryOpenReason from "./components/QueryOpenReason";
import { cleanWizard } from "../../services/state/actions";

import ModalProducts from "./components/ModalProducts";
import ModalProductConfirm from "./components/ModalProductConfirm";
import ModalOdinIncident from "./components/ModalOdinIncident";
import ModalCommonIncident from "./components/ModalCommonIncident";
import ModalSelectReason from "./components/ModalSelectReason";
import ModalAutoFixCounter from "./components/ModalAutoFixCounter";
import ModalProblemSolved from "./components/ModalProblemSolved";
import ModalMassive from "./components/ModalMassive";
import ModalRepairExists from "./components/ModalRepairExists";
import ModalGeneralError from "./components/ModalGeneralError";
import ModalSuccessfulRepair from "./components/ModalSuccessfulRepair";
import ModalClearChannel from "./components/ModalClearChannel";
import ModalInternetLink from "./components/ModalInternetLink";
import ModalTotalVoice from "./components/ModalTotalVoice";
import ModalVideoConference from "./components/ModalVideoConference";

const Checklists = {
  "Clear Channel": ModalClearChannel,
  "LAN to LAN Node": ModalClearChannel,
  "LAN to LAN Network": ModalClearChannel,
  "Internet Link": ModalInternetLink,
  VPN: ModalInternetLink,
  "Voz Total": ModalTotalVoice,
  "Projeto Especial Node": ModalVideoConference,
  "IP Transito": ModalInternetLink,
};

class RepairWizard extends Component {
  selectedProductWith = (propName, values) => {
    return contains(this.props.product[propName], values);
  };

  isProductSystem = (values) => {
    return this.selectedProductWith("productSystem", values);
  };

  isLineOfBusiness = (values) => {
    return this.selectedProductWith("lineOfBusiness", values);
  };

  isAutomaticOrLandline = () => {
    const result = and(
      this.isProductSystem(["VANTIVE", "ALGAR CRM"]),
      this.isLineOfBusiness([
        "COMUNICACAO DADOS",
        "TELEFONIA FIXA",
        "BANDA LARGA",
      ])
    );
    window.log("isAutomaticOrLandline", result);
    return result;
  };

  isAutomatic = () => {
    const result = this.isLineOfBusiness(["COMUNICACAO DADOS", "BANDA LARGA"]);
    window.log("isAutomatic", result);
    // return
    return result;
  };

  isLandline = () => {
    const result = this.isLineOfBusiness(["TELEFONIA FIXA"]);
    window.log("isLandline", result);
    return result;
  };

  isSiebel = () => {
    return this.isProductSystem(["SIEBEL"]);
  };

  isOdin = () => {
    return this.isProductSystem(["ODIN"]);
  };

  getChecklistName = () => {
    const { product } = this.props;
    return find(
      (productName) =>
        contains(productName, removeAccents(product.productName)),
      keys(Checklists)
    );
  };

  getChecklistComponent = () => {
    return Checklists[this.getChecklistName()];
  };

  hasChecklist = () => {
    return !!this.getChecklistName();
  };

  onAbort = () => {
    this.props.cleanWizard();
    this.props.onClose();
  };

  hasErrorCode = (value) => {
    const { openingOs } = this.props;
    return contains(openingOs.errorCode, value);
  };

  render() {
    const { openingOs } = this.props;
    return (
      <Wizard
        onReset={this.onAbort}
        onBeforeFirstStep={this.onAbort}
        onAfterLastStep={this.onAbort}
      >
        <WizardStep key="product" component={ModalProducts} />
        <WizardStep key="product-confirm" component={ModalProductConfirm} />

        <WizardSwitch key="repair-mode">
          <Wizard key="automatic-or-landline" test={this.isAutomaticOrLandline}>
            <WizardStep
              key="autofix-common-incident"
              component={ModalCommonIncident}
            />
            <WizardSwitch key="automatic-or-landline-flow">
              <Wizard key="automatic" test={this.isAutomatic}>
                <WizardStep
                  key="automatic-query-open-reason"
                  component={QueryOpenReason}
                />

                {/* Fluxo dependente do errorCode [0, 1, 13, 99] */}
                <WizardSwitch key="error-codes">
                  <Wizard key="autofix" test={() => this.hasErrorCode(["0"])}>
                    {/* operações de configuração */}
                    {/* Action: repairAutomatically */}
                    {/* Tratar erro se exceder 4min no componente */}
                    <WizardStep
                      key="autofix-counter"
                      component={ModalAutoFixCounter}
                    />
                    <WizardStep
                      key="problem-solved-confirmation"
                      component={ModalProblemSolved}
                    />

                    <WizardSwitch key="problem-result">
                      {/* Se resolvido */}
                      <Wizard key="problem-solved" test={() => {}}>
                        <WizardStep
                          key="autofix-successful-1"
                          component={ModalSuccessfulRepair}
                        />
                      </Wizard>

                      {/* Se não resolvido */}
                      <Wizard key="problem-dont-solved" test={() => {}}>
                        <WizardStep
                          key="autofix-reason-selection"
                          component={ModalSelectReason}
                        />

                        <WizardSwitch key="autofix-checklists">
                          <WizardStep
                            key="autofix-has-checklist"
                            test={this.hasChecklist}
                            component={this.getChecklistComponent}
                          />
                          <WizardStep
                            key="autofix-common-incident"
                            test={not(this.hasChecklist)}
                            component={ModalCommonIncident}
                          />
                        </WizardSwitch>

                        <WizardStep
                          key="autofix-successful-2"
                          component={ModalSuccessfulRepair}
                        />
                      </Wizard>
                    </WizardSwitch>
                  </Wizard>

                  <WizardStep
                    key="existing-repair-1"
                    test={() => this.hasErrorCode(["1"])}
                    protocol={openingOs.errorDesc}
                    component={ModalRepairExists}
                    messageKey="OPEN_REASON_ERROR_CODE_1"
                  />
                  <WizardStep
                    key="existing-repair-12"
                    test={() => this.hasErrorCode(["12"])}
                    protocol={openingOs.errorDesc}
                    component={ModalRepairExists}
                    messageKey="OPEN_REASON_ERROR_CODE_12"
                  />
                  <WizardStep
                    key="massive"
                    test={() => this.hasErrorCode(["13"])}
                    component={ModalMassive}
                  />
                  <WizardStep
                    key="general-error-2"
                    test={() => this.hasErrorCode(["2"])}
                    component={ModalGeneralError}
                    messageKey="OPEN_REASON_ERROR_CODE_2"
                  />
                  <WizardStep
                    key="general-error-3"
                    test={() => this.hasErrorCode(["3"])}
                    component={ModalGeneralError}
                    messageKey="OPEN_REASON_ERROR_CODE_3"
                  />
                  <WizardStep
                    key="general-error-99"
                    test={() => this.hasErrorCode(["99"])}
                    component={ModalGeneralError}
                    messageKey="OPEN_REASON_ERROR_CODE_99"
                  />
                </WizardSwitch>
              </Wizard>

              <Wizard key="landline" test={this.isLandline}>
                <WizardStep
                  key="landline-query-open-reason"
                  component={QueryOpenReason}
                />
                <WizardStep
                  key="landline-reason-selection"
                  component={ModalSelectReason}
                />

                <WizardSwitch key="landline-checklists">
                  <WizardStep
                    key="landline-has-checklist"
                    test={this.hasChecklist}
                    component={this.getChecklistComponent}
                  />
                  <WizardStep
                    key="landline-common-incident"
                    test={() => not(this.hasChecklist())}
                    component={ModalCommonIncident}
                  />
                </WizardSwitch>

                <WizardStep
                  key="landline-successful"
                  component={ModalSuccessfulRepair}
                />
              </Wizard>
            </WizardSwitch>
          </Wizard>

          <Wizard key="siebel" test={this.isSiebel}>
            <WizardStep
              key="siebel-query-open-reason"
              component={QueryOpenReason}
            />

            {/* Fluxo dependente do errorCode [1, 13, 99] */}
            <WizardSwitch key="error-codes">
              <WizardStep
                key="existing-repair-1"
                test={() => this.hasErrorCode(["1"])}
                protocol={openingOs.errorDesc}
                component={ModalRepairExists}
                messageKey="OPEN_REASON_ERROR_CODE_1"
              />
              <WizardStep
                key="existing-repair-12"
                test={() => this.hasErrorCode(["12"])}
                protocol={openingOs.errorDesc}
                component={ModalRepairExists}
                messageKey="OPEN_REASON_ERROR_CODE_12"
              />
              <WizardStep
                key="massive"
                test={() => this.hasErrorCode(["13"])}
                component={ModalMassive}
              />
              <WizardStep
                key="general-error-2"
                test={() => this.hasErrorCode(["2"])}
                component={ModalGeneralError}
                messageKey="OPEN_REASON_ERROR_CODE_2"
              />
              <WizardStep
                key="general-error-3"
                test={() => this.hasErrorCode(["3"])}
                component={ModalGeneralError}
                messageKey="OPEN_REASON_ERROR_CODE_3"
              />
              <WizardStep
                key="general-error-99"
                test={() => this.hasErrorCode(["99"])}
                component={ModalGeneralError}
                messageKey="OPEN_REASON_ERROR_CODE_99"
              />
              <WizardStep
                key="siebel-has-checklist"
                test={() => this.hasErrorCode(["0"]) && this.hasChecklist}
                component={this.getChecklistComponent}
                checklist
              />
              <WizardStep
                key="siebel-common-incident"
                test={() =>
                  not(this.hasChecklist()) && this.hasErrorCode(["0"])
                }
                component={ModalCommonIncident}
              />
            </WizardSwitch>

            <WizardStep
              key="siebel-successful"
              component={ModalSuccessfulRepair}
            />
          </Wizard>

          <Wizard key="odin" test={this.isOdin}>
            <WizardStep
              key="odin-common-incident"
              component={ModalOdinIncident}
            />
            <WizardStep
              key="odin-successful"
              component={ModalSuccessfulRepair}
            />
          </Wizard>

          {/* <WizardOtherwise component={} /> */}
        </WizardSwitch>
      </Wizard>
    );
  }
}

const mapStateToProps = ({ repair, auth }) => ({
  auth,
  product: repair.wizard.product,
  reason: repair.wizard.reason,
  openingOs: repair.openingOs,
});

const enhance = compose(translate(), connect(mapStateToProps, { cleanWizard }));

export default enhance(RepairWizard);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/index.js